import { c as _c } from "react-compiler-runtime";
import { useEffect } from 'react';
import { useCellSelectionStore } from '../../redux/reduxHooks';
import { useCopySelectionRef } from '../context/CellSelectionContext';
import { getSelectedCellCoords } from '../redux/cellSelectionSlice';
import { isPlatformModifierKey } from '../utils/isMacOs';

/**
 * Cmd/Ctrl+C copies the selected cells to the clipboard. Only called from
 * CellSelectionEffects, which is mounted only when cell selection is enabled.
 * If no cells are selected the handler is a no-op so the browser's native copy
 * behavior runs. The actual serialization + staging lives in the shared
 * copySelection routine published by CellSelectionEffects (read here via the
 * cell-selection context ref), so this path is identical to the action menu's
 * Copy button.
 */
export const useCopyCellSelection = () => {
  const $ = _c(4);
  const store = useCellSelectionStore();
  const copySelectionRef = useCopySelectionRef();
  let t0;
  let t1;
  if ($[0] !== copySelectionRef || $[1] !== store) {
    t0 = () => {
      const handleKeyDown = e => {
        var _copySelectionRef$cur;
        if (e.target instanceof Element && e.target.closest("input, textarea, [contenteditable=\"true\"]")) {
          return;
        }
        const isCopyShortcut = isPlatformModifierKey(e) && e.key === "c";
        if (!isCopyShortcut) {
          return;
        }
        const coords = getSelectedCellCoords(store.getState());
        if (coords.length === 0) {
          return;
        }
        e.preventDefault();
        (_copySelectionRef$cur = copySelectionRef.current) === null || _copySelectionRef$cur === void 0 || _copySelectionRef$cur.call(copySelectionRef, "keyboard_shortcut");
      };
      document.addEventListener("keydown", handleKeyDown);
      return () => document.removeEventListener("keydown", handleKeyDown);
    };
    t1 = [store, copySelectionRef];
    $[0] = copySelectionRef;
    $[1] = store;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
};